import React from 'react'

import Translator from 'bazinga-translator'
import Button from 'components/Btn'
import withCondition from 'components/withCondition'
import { GameWithUserInformation } from 'containers/GamesBlock/types'

import useGameDialog from '../MobileDialog/hooks/useGameDialog'

interface Props {
  game: GameWithUserInformation
}

function RealPlayButtonComponent({ game }: Props) {
  const { realPlayUrl } = game
  const { close } = useGameDialog()

  return (
    <Button
      md
      primary
      onClick={() => close()}
      href={realPlayUrl}
    >
      {Translator.trans('play_for_real', {}, 'games')}
    </Button>
  )
}

export const RealPlayButton = withCondition(RealPlayButtonComponent)
